import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY, BILLING_ALERTS_STATES} from 'util/constants';

const _getFetchParams = (filters, pagination, sortBy) => ({
    ...pagination,
    state:       filters.states,
    entity_type: filters.types,
    ordering:    sortBy,
    search:      filters.search
});

const _getEntities = entities => {
    if (entities) {
        return entities.map(item => item.id);
    }

    return entities;
};

const
    mapFields = {
        entityType: 'entity_type',
        updateDate: 'update_date'
    },
    transformEntitiesToSaveFn = item => ({
        active:      item.active,
        amount:      item.amount,
        entities:    item.entities,
        id:          item.id,
        emails:      item.emails,
        name:        item.name,
        state:       item.state,
        entity_type: item.entityType,
        mode:        item.mode,
        exclude:     item.exclude
    }),
    transformEntitiesToEdit = item => ({
        active:      item.active,
        amount:      item.amount,
        entities:    _getEntities(item.entities),
        id:          item.id,
        emails:      item.emails,
        name:        item.name,
        state:       item.state,
        entity_type: item.entityType,
        mode:        item.mode
    });

module.exports = {
    mapFields,
    transformEntitiesToSaveFn,
    createFetchParams: (filters, pagination, sortBy) => _getFetchParams(filters, pagination, sortBy),
    ...storeModuleFactory({
        name:            'billingAlerts',
        endpoint:        endpoints.billingAlerts.endpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        filterParamsMap: {
            serviceOffering: 'service_offering',
            status:          'state'
        },
        sortParamsMap: {
            state:    'state',
            name:     'name',
            entities: 'entities',
            amount:   'amount',
            active:   'active'
        },
        instanceEndpoint:    endpoints.billingAlerts.instanceEndpoint,
        transformEntitiesToSaveFn,
        transformEntitiesFn: item => ({
            id:         item.id,
            entities:   item.entities,
            entityType: item.entity_type,
            emails:     item.emails,
            name:       item.name,
            state:      item.state,
            amount:     item.amount,
            lastCheck:  item.last_check * TIMESTAMP_MULTIPLY,
            active:     item.state !== BILLING_ALERTS_STATES.DISABLED
        }),
        extraActions: [{
            method: 'update',
            action: 'switchState',
            url:    endpoints.billingAlerts.instanceEndpoint,
            start:  state => ({
                ...state,
                isUpdating: true,
                error:      null
            }),
            success: state => ({
                ...state,
                isUpdating:    false,
                didInvalidate: true,
                error:         null
            }),
            transform: item => transformEntitiesToEdit(item)
        }]
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/billingAlerts.js